import {Injectable} from '@angular/core';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {ProductRetrocessionConverter} from '../../../api/entity/converter/productRetrocession.converter';
import {ProductRetrocessionModel} from '../../../api/entity/productRetrocession.model';
import {ProductRetrocessionDataService} from './productRetrocessionData.service';

@Injectable()
export class ProductRetrocessionDataServiceAdapter
    extends AbstractDataServiceDtoAdapter<ProductRetrocessionModel, ProductRetrocessionConverter> {
    constructor(dataService: ProductRetrocessionDataService, converter: ProductRetrocessionConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): ProductRetrocessionModel {
        return new ProductRetrocessionModel();
    }
}
